import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { SearchBar } from "@/components/search-bar";
import { useTableControl } from "@/components/table-control";
import { useFetchRecordingTags } from "@/features/recording-tags/api/fetch-recording-tags";
import { RecordingTagsTable } from "@/features/recording-tags/components/recording-tags-table";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";

export function AdminTagsPage() {
  const { search, setSearch } = useTableControl();
  const { id: organisationId } = useParams();

  const {
    data: tagsData,
    isLoading,
    isSuccess,
    isError,
    isFetching,
    isPlaceholderData,
    error,
  } = useFetchRecordingTags({
    organisationId: organisationId ?? "",
  });

  const filteredData = useMemo(() => {
    if (!tagsData) return [];

    return tagsData.filter((tag) =>
      tag.name.toLowerCase().includes(search?.toLowerCase() ?? ""),
    );
  }, [tagsData, search]);

  if (isLoading)
    return (
      <div>
        <OnboardingHeader
          title="Tags"
          description="View and manage Tags"
          className="mb-6"
        />
        <LoadingScreen />
      </div>
    );

  if (isError || !isSuccess)
    return (
      <div>
        <OnboardingHeader
          title="Tags"
          description="View and manage Tags"
          className="mb-6"
        />
        <ErrorMessage error={error} />
      </div>
    );
  return (
    <section>
      <OnboardingHeader
        title="Tags"
        description="View and manage Tags"
        className="mb-6"
      />
      <div className="mb-2 justify-between sm:flex">
        <SearchBar
          search={search}
          setSearch={setSearch}
          className="mb-2 sm:mb-0 sm:max-w-xs"
        />
      </div>
      <RecordingTagsTable
        data={filteredData}
        isLoading={isFetching && isPlaceholderData}
        organisationId={organisationId ?? ""}
      />
    </section>
  );
}
